import React from "react";
import {
  Typography,
  Divider,
} from "@mui/material";
import Gusto from "../images/Gusto.png"

export default function Article2(props: any) {

  return (
    <div>
      <title>"Who'd We Get?" - A Recap of the Miami Marlins' Trade Deadline (ft. Alex Carver of Fish on the Farm)</title>
      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          color: "#000000",
          textAlign: "center",
          fontSize: props.isDesktop ? "34pt" : "20pt",
        }}
      >
        "Who'd We Get?" - A Recap of the Miami Marlins' Trade Deadline (ft. Alex Carver of Fish on the Farm)
      </Typography>
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          fontSize: props.isDesktop ? "18pt" : "14pt",
        }}
      >
        By Alex Carver • August 16th, 2025
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />

      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Surprisingly riding high heading into the All-Star Break, the Marlins suddenly had an interesting decision to make: go all-in on 2025, stay committed to their rebuild now in its second year, or toe the line and do a little bit of both. At the end of the day, things could have wound up going in any of those directions. Where it eventually landed was on the latter. The Marlins moved off of one of their top MLB offensive talents and a solid defensive MLB catcher while buying into budding house options, but stayed pat on their most prized and most asked about assets, their starting pitchers; namely Sandy Alcantara and Edward Cabrera. Here’s a closer look at the deals that were made, what the returns mean for Miami, and where things stand for the franchise for the rest of this year and beyond.
        <br /><br />
      </Typography>

      {/* Fortes Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Rays Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>C Nick Fortes</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Marlins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            OF Matthew Etzel
          </div>
        </div>
      </div>


      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        To say MLB-caliber catching is at a premium these days would be a massive understatement. This trade couldn’t be a better microcosm of that truth.
        <br /><br />
        Nick Fortes was drafted by the Marlins out of the University of Mississippi in 2018. Always decent on the defensive side, Fortes didn’t start figuring out how to somewhat consistently hit in the minors until after he made his big league debut in 2022. During his first two full length big league season in 2023, his offensive holes were well pronounced. Between 2023 and 2024, Fortes was a negative WAR player with a .216/.261/.309 slash line. This season, the 28-year-old brought his batting average up to at least respectable levels. The tipping point for a trade though was the fact that his defense took an even larger step. To this day, Fortes still ranks in 89th percentile in blocking, the 74th percentile in framing, and the 77th percentile in pop time. The data driven Rays bought in on the defensive metrics very early in the deadline process, sending the Marlins a Double-A prospect in return.
        <br /><br />
        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          OF Matthew Etzel
        </Typography>
        <br />
        Going back to the Marlins was outfielder Matthew Etzel. A lefty-hitting, righty-throwing newly turned 23 year old, Etzel stands out in his ability to exhibit great patience at the plate. Over the course of his three year MiLB career, he has a .365 OBP with a 201/111 K/BB. Jumping between the A+ and AA level in 2024, he slashed .272/.345/.430. He joined the Marlins while on the short-term injured list but has already made his organizational debut, first in a rehab capacity and now with the Pensacola Blue Wahoos.
        <br /><br />
        A former 10th round pick who needs to find more solid contact against upper minors stuff but who also doesn’t strike out frequently, the Marlins believe they can unlock even more from this buy-low prospect. Etzel also has decent speed, giving him the ability to man all three outfield spots. With a solid floor and room to grow, he’s more than the Marlins could’ve hoped for for the current version of Fortes, who they will eventually replace with star prospect Joe Mack. Miami struck while the iron was hot here in terms of available MLB catchers and did well.
        <br /><br />
      </Typography>

      {/* Sanchez Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Astros Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>OF Jesus Sanchez</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Marlins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
           <a href="/player/687473 " style={{ color: "#0d6efd", textDecoration: "none" }}>RHP Ryan Gusto</a>,<br />
            SS Chase Jaworsky,<br />
            OF Esmil Valencia
          </div>
        </div>
      </div>


      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Sanchez entered 2025 as one of the longest-tenured current Miami position players. After improving his swing decisions and patience at the plate versus his career norms while maintaining plus power from the left side and a plus throwing arm, he became a sought after commodity for teams seeking outfield help. Queue the Astros, who have a very small outfield and an environment perfectly befitting Sanchez’s skill set on both sides of the baseball. The Astros don’t boast one of the best — or even average — MiLB systems, so to get it done, it was going to take multiple pieces. The deal was Sanchez for three B-type prospects.
        <br /><br />
        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP Ryan Gusto
        </Typography>
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Gusto}
            alt="Ryan Gusto pitch metrics"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>
        With Gusto, the Marlins are buying in on a solid ground floor with the potential for a very solid ceiling. 6’4”, 232, Gusto is a late bloomer but he has a solid fastball up to 97. He’s also made recent improvements in the area of movement with the pitch, particularly its average vertical break. He can also throw the fastball with two seam action, a trend <a href="https://fishonfirst.com/profile/25143-sean-mccormack/">Fish on First’s Sean McCormack</a> expects to continue, further helping ground ball rates. Arguably, Gusto’s best pitch is a changeup sitting at 88 and approaching the low 90s which he commands well. He also owns a solid slider, a decent sweeper, and a mix-in curveball. A guy the Marlins can develop in a multitude of ways given his ability to throw a wide variety of pitches and already succeed with at least two of them, he is a Marlins pitching development darling. He has the floor of a multiple inning reliever, but a higher ceiling as a back end rotational piece.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        SS Chase Jaworsky
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Jaworsky is a young lefty hitting infielder whose best current tool is plus speed. He also shows good bat to ball skills and solid patience. Thus far in his MiLB career, he has a 125/61 K/BB and 52 stolen bases while jumping a level each season. Thus far in High-A this year, he’s slashing .242/.353/.359. His speed also serves him well in the field where he shows consistent range to both sides and an accurate throwing arm which should allow him to stick at shortstop.
        <br /><br />
        The main improvement the 6’1”, 171 pounder will need to make as he joins the Marlins hitting development system is making more line drive contact and finding more gaps to even out what is right now a very high soft ground ball rate. At 21, Jaworsky has a lot of the hard aspects of hitting and fielding under his belt already. With natural progression both physically and mentally and under the tutelage of the Marlins’ data-driven system, he’s in a good spot to make the most of his potential and reach the ceiling of a twitchy top of the order bat from the left side who will threaten on the base paths and hold down a premium position.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        OF Esmil Valencia
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Valencia is a 19-year-old outfielder signed by the Astros in 2023 as a ranked international prospect, earning a lucrative $900K. Like his aforementioned teammates, he’s jumped a level each season, coming stateside in 2024 and participating in full-season ball for the first time this season. Valencia has elite speed, approaching 70 grade. This season, his 56 stolen bases are eighth in all of Minor League Baseball. In his 91 games, he’s also exhibiting good bat to ball skills, playing to a .275 average. He’s also starting to tap into some power by hitting six home runs. Staying patient and avoiding whiffs especially against breaking stuff and early in counts will be paramount for Valencia as he continues to grow and round into form. On his current trajectory, Valencia profiles as at least a three-tool player. His run tool and plus arm serve him well in the field and should allow him to stick as a center fielder, but the corners may be smarter to take pressure off the bat and allow his full power potential to come to fruition.
        <br /><br />
      </Typography>

      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Overall, the Marlins weren’t as active as they could have been at the deadline, but they didn’t have to be. Holding their starting pitching assets for the rest of the season will help keep the team suprisingly competitive while helping maximize future value, which could be explored again this offseason. It will also allow their top pitching prospects to develop further. The two players the Marlins did decide to part with had their trade values capped and the club had clear in-house options, Agustín Ramirez and Jakob Marsee waiting in the wings to fully take the reigns at their respective positions. What Miami did add was a group of four prospects all with solid floors that will continue to add to the feeder system the organization has quickly developed. While the rebuild isn’t exactly over, it is well ahead of schedule. Playing with house money the rest of this season however far it goes, the team is already starting to see the exports of their new analytically-driven player development system. One of the best stories in baseball both before and after the deadline, Peter Bendix and Company as well as the fan base have to be pretty pleased with where the organization is right now.
      </Typography>
      <br /><br />
      <Typography
        variant="body1"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "15pt"
        }}
      >
        If you enjoyed this piece, check out <a href="https://x.com/marlinsminors">Fish on the Farm on X</a> and <a href="https://fishonfirst.com/">Fish on First</a> for more Marlins content.
      </Typography>
    </div>
  );
}
